
<div class="card">
    <img alt='picture' src='/assets/img/user-head.svg'
               alt="profile picture">
    <h1>professor</h1>
    <h2>max mustermann</h2>
    <a class="button" href="#">send a message</a>
</div>